import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { areCurrentNoteCommentsActive } from 'data/activityRegistry/selectors'
import { getCurrentNoteThreadsNotificationsCount } from 'data/notifications/selectors'
import { selectors as UISelectors, actions as UIActions } from 'data/ui'

import { measureTimingStart } from 'data/metrics'
import { withNoteMetaPanelControls } from 'routes/utils/withNoteMetaPanelControls'

import IconButton from 'components/Utils/IconButton'
import * as Icons from 'components/Utils/Icons'

const MIN_WINDOW_WIDTH_TO_DISPLAY_COMMENTS = 1000

export class CommentsButton extends Component {
  static propTypes = {
    notificationsCount: PropTypes.number.isRequired,
    hasActivity: PropTypes.bool.isRequired,
    isCommentsOpen: PropTypes.bool,
  }

  render() {
    const {
      notificationsCount,
      isCommentsOpen,
      isDetachedMode,
      toggleComments,
      hasActivity,
    } = this.props

    return (
      <IconButton
        style={{ marginBottom: 2 }}
        tooltip={
          isCommentsOpen ? 'Close comments panel' : 'Open comments panel'
        }
        tooltipPosition="left"
        onClick={() => {
          measureTimingStart('TIME_TO_OPEN_COMMENTS')
          if (
            isDetachedMode &&
            window.outerWidth < MIN_WINDOW_WIDTH_TO_DISPLAY_COMMENTS &&
            !isCommentsOpen
          ) {
            window.resizeTo(1000, window.outerHeight)
          }
          toggleComments()
        }}
      >
        {notificationsCount > 0 && !isCommentsOpen ? (
          <div
            className="flexbox flexbox-centered shade-100-important bold radius-round center-text background-red"
            style={{ width: 22, height: 22 }}
          >
            {notificationsCount}
          </div>
        ) : (
          React.createElement(
            hasActivity ? Icons.CommentsIcon : Icons.CommentsEmptyIcon,
            {
              className: hasActivity ? 'red' : '',
              size: 16,
            }
          )
        )}
      </IconButton>
    )
  }
}

export default compose(
  withNoteMetaPanelControls,
  connect(
    state => ({
      hasActivity: areCurrentNoteCommentsActive(state),
      notificationsCount: getCurrentNoteThreadsNotificationsCount(state),
      isDetachedMode: UISelectors.isDetachedModeEnabled(state),
    }),
    {
      toggleFocusMode: UIActions.toggleFocusMode,
    }
  )
)(CommentsButton)
